import { createFileRoute } from '@tanstack/react-router';

import { Contact } from '@/components/content/Contact';

export const Route = createFileRoute('/_map/_sidebar/contact')({
  beforeLoad: ({ search }) => {
    const { resultIndex, ...rest } = search as { resultIndex?: number } & Record<string, unknown>;

    return { search: rest };
  },
   
  component: Contact,
});
